<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <!-- generalMenu -->
      <section>
        <fieldset formGroupName="generalMenu">
          <legend>
            {{ pageVocabs + "legends.generalMenu" | translate }}
          </legend>

          <div class="row">
            <!-- Specifications -->
            <div class="md:tw-w-1/2 xl:tw-w-1/3">
              <div class="row">
                <!-- name -->
                <div class="tw-w-full">
                  <form-field
                    [(value)]="model.title"
                    [control]="form?.get('generalMenu.title')"
                    label="common.title"
                    classList="dir-ltr"
                  >
                  </form-field>
                </div>

                <!-- parentId -->
                <div class="xl:tw-w-full">
                  <menu-select-search
                    [id]="
                      formPageConfig.isEditMode ? formPageConfig.editId : null
                    "
                    [control]="form?.get('generalMenu.parentId')"
                    label="common.parent"
                    [(value)]="model.parentId"
                    (onError)="onClose()"
                  >
                  </menu-select-search>
                </div>

                <!-- route -->
                <div class="tw-w-full">
                  <form-field
                    [(value)]="model.route"
                    [control]="form?.get('generalMenu.route')"
                    [label]="fields + 'route'"
                    [id]="formPageConfig.editData?.id"
                    classList="dir-ltr"
                  >
                  </form-field>
                </div>

                <!-- class -->
                <div class="tw-w-full">
                  <form-field
                    [(value)]="model.class"
                    [control]="form?.get('generalMenu.class')"
                    [label]="fields + 'class'"
                  >
                  </form-field>
                </div>

                <!-- icon -->
                <div class="tw-w-full">
                  <form-field
                    [(value)]="model.icon"
                    [control]="form?.get('generalMenu.icon')"
                    [label]="'common.icon' | translate"
                    classList="dir-ltr"
                  >
                  </form-field>
                </div>

                <!-- order -->
                <div class="tw-w-full">
                  <form-field
                    [(value)]="model.order"
                    type="number"
                    [control]="form?.get('generalMenu.order')"
                    [label]="fields + 'order'"
                  >
                  </form-field>
                </div>
              </div>
            </div>

            <!-- claims -->
            <div class="md:tw-w-1/2 xl:tw-w-2/3">
              <h3 class="tw-mr-3">{{ "common.claimGroup" | translate }}</h3>
              <claim-selection-list
                searchLabel="common.search"
                (values)="model.claimIds = $event"
                [values]="model.claimIds"
                responsiveClass="tw-w-full"
                searchBoxGridclass="tw-w-full"
              >
              </claim-selection-list>
            </div>
          </div>
        </fieldset>
      </section>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
